<template>
  <div>
    <el-tabs v-model="activeTabName" type="card" style="margin-top: 8px;" @tab-click="handleClick">
      <el-tab-pane :label="$t('CargoMsg.Cargo_MaritimeIdentification')" name="ocrSe">
        <div style="display: flex;padding-left: 8px;padding-top: 8px;">
          <div v-if="!isPlatform" class="filters">
            <el-form :inline="true" label-width="100px" label-position="right">
              <div class="el-form-item-wrapper">
                <el-form-item label-width="50px" :label="$t('SystemMaintenance.Branch')">
                  <el-select v-model="branchId" no="1" @change="changeBranch()">
                    <el-option
                      v-for="office in currentOfficeList"
                      :key="office.officeId"
                      :value="office.officeId"
                      :label="office.code"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item v-show="branchId!==1" :label="$t('SystemMaintenance.ApplyTheHeadOfficesSettings')">
                  <el-checkbox v-model="ifHq" no="2" @change="applyHq" />
                </el-form-item>
              </div>
            </el-form>
            <br>
          </div>
          <div class="show-right">
            <div class="main-content left" style="margin-top: 20px;margin-left: 30px;">
              <el-form :inline="true" label-width="100px" label-position="right">
                <div style="margin-bottom: 5px">
                  <span v-if="otherField.ifDefaultConfig && !isPlatform" style="font-size: 14px;color: #acacac;" v-html="$t('CargoMsg.Cargo_OcrSetTip')" />
                </div>
                <div class="el-form-item-wrapper" style="padding-top: 10px; padding-bottom: 10px">
                  <span style="font-size: 18px;padding-right: 95px ">{{ $t('CargoMsg.Cargo_ApplicationIdentificationType') }}</span>
                  <el-form-item label-width="200px" :label="''">
                    <el-select v-model="useCase" no="1" style="width: 200px;" @change="refresh">
                      <el-option
                        v-for="(item,index) in typeList()"
                        :key="index"
                        :label="$getLangColumn(item)"
                        :value="item.code"
                      />
                    </el-select>
                  </el-form-item>
                </div>
              </el-form>

              <!--              <span style="font-size: 18px;">{{ $t('SeaExport.ocrOtherField') }}</span>-->
              <!--              <div style="width: 600px;">-->
              <!--                <el-form style="margin-top: 20px">-->
              <!--                  <el-row :gutter="10" type="flex" style="margin: 0">-->
              <!--                    <el-col :span="8">-->
              <!--                      <el-form :disabled="readonly">-->
              <!--                        <el-form-item v-for="item in SystemConstants.OCR_FIELDS" :key="item.code">-->
              <!--                          <el-checkbox v-model="form[item.code]" :no="item.code" @change="toPattern(item.code)">{{ isZh ? item.chineseName : item.englishName }}</el-checkbox>-->
              <!--                        </el-form-item>-->
              <!--                      </el-form>-->
              <!--                    </el-col>-->
              <!--                    <el-col :span="8" style="display:flex;flex-direction: column">-->
              <!--                      <div style="display: flex;flex-grow: 1">-->
              <!--                        <div style="display: flex;flex-grow: 1;flex-direction: column">-->
              <!--                          <el-table-->
              <!--                            ref="table"-->
              <!--                            :class="readonly?'not-click':''"-->
              <!--                            :data="expressList"-->
              <!--                            :show-header="false"-->
              <!--                            border-->
              <!--                            highlight-current-row-->
              <!--                            style="flex-grow:1; width: 200px;"-->
              <!--                            @current-change="handleCurrentChange"-->
              <!--                          >-->
              <!--                            <el-table-column>-->
              <!--                              <template slot-scope="{row}">-->
              <!--                                <div style="padding:0 3px 0 5px">-->
              <!--                                  <span>{{ ColumnUtils.columnLabelFunc(SystemConstants.OCR_FIELDS, row.name) }}</span>-->
              <!--                                </div>-->
              <!--                              </template>-->
              <!--                            </el-table-column>-->
              <!--                          </el-table>-->
              <!--                        </div>-->
              <!--                        <div class="flex-column">-->
              <!--                          <el-button :disabled="readonly" type="primary" no="6" style="margin-left: 5px;margin-bottom: 5px" @click="moveUp">↑</el-button>-->
              <!--                          <el-button :disabled="readonly" type="primary" no="7" @click="moveDown">↓</el-button>-->
              <!--                        </div>-->
              <!--                      </div>-->
              <!--                    </el-col>-->
              <!--                  </el-row>-->
              <!--                </el-form>-->
              <!--              </div>-->

              <div style="width: 400px;">
                <div style="display: flex;flex-direction:column;flex-wrap: wrap;max-height: 700px;">
                  <div v-for="item in fieldDefineList" :key="item.code" style="padding: 7px;width: 33%">
                    <el-checkbox v-model="otherField.fieldSelectedVo[item.code]" :disabled="item.disabled || readonly" :no="item.code" @change="fieldCheckboxHandle(item)">{{ isZh ? item.chineseName : item.englishName }}</el-checkbox>
                  </div>
                </div>
              </div>

            </div>

            <div class="division">
              &nbsp;
            </div>
            <div class="middle" style="margin-top: 20px;margin-left: 30px">
              <div style="padding-top: 10px; padding-bottom: 10px">
                <span style="font-size: 18px;margin-right: 50px">{{ $t('CargoMsg.Cargo_BookNoteFieldAndSort') }}</span>
                <el-button v-if="readonly" :disabled="ifHq" type="primary" no="3" @click="edit()"> {{ $t('common.btn.edit') }} </el-button>
                <el-button v-if="!readonly" :disabled="ifHq" type="primary" no="4" @click="cancel()"> {{ $t('common.btn.cancel') }} </el-button>
                <el-button v-if="!readonly" :disabled="ifHq" type="primary" no="5" style="margin-left: 5px;" @click="saveOcrField(false)"> {{ $t('common.btn.save') }} </el-button>
                <el-button v-if="readonly" :disabled="ifHq" type="primary" no="checkSetting" style="margin-left: 5px;" @click="checkSetting()"> {{ $t('CargoMsg.Cargo_CheckSetting') }} </el-button>
              </div>
              <draggable v-model="otherField.ocrOtherFieldDetails" :disabled="readonly" animation="300" style="width: 100%;cursor: pointer;" @update="onDragUpdate">
                <transition-group style="width: 100%;display: flex;flex-direction:column;flex-wrap: wrap;max-height: 710px;align-content: flex-start">
                  <div
                    v-for="(item, index) in otherField.ocrOtherFieldDetails"
                    :key="item.code"
                    class="item"
                    style="padding: 9px;width: 24%;border: 1px solid #f5f5f5;margin-top: -1px;margin-right: -1px"
                  >
                    <div style="display:flex;justify-content: space-between">
                      {{ isZh ? fieldDefineMap[item.code].chineseName : fieldDefineMap[item.code].englishName }}
                      <img src="/static/move.svg" style="align-self: center;margin-left:5px;width:11px;height:11px;">
                    </div>
                  </div>
                </transition-group>
              </draggable>
            </div>

            <div class="division">
              &nbsp;
            </div>
            <div class="right">
              <div style="margin-top: 20px;margin-left: 30px;">
                <div>
                  <span style="font-size: 18px">{{ $t('SeaExport.ocrTextMapper') }}</span>
                  <el-button type="primary" :disabled="ifHq" no="8" style="margin-left: 100px;" @click="addMapper()"> {{ $t('SeaExport.Add') }} </el-button>
                  <el-button type="primary" :disabled="ifHq" no="9" style="margin-left: 5px;" @click="editMapper()"> {{ $t('SeaExport.Edit') }} </el-button>
                  <el-button type="danger" :disabled="ifHq" no="10" style="margin-left: 5px;" @click="deleteMapper()"> {{ $t('SeaExport.Delete') }} </el-button>
                </div>
                <div style="width: 600px;margin-top: 30px;">
                  <cargo-ag-grid
                    :show-side-bar="false"
                    :grid-options="gridOptions"
                    :column-defs="columnDefs"
                    :row-data="textRowData"
                    style="width:100%;height:400px;margin-top: 10px;"
                    @gridReady="params=>{gridApi=params.api}"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>

    <!-- 映射弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="mapperDialog.visible"
      :title="mapperDialog.title"
      width="400px"
      :close-on-click-modal="false"
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <el-form label-width="110px" label-position="left">
          <el-form-item :label="$t('CargoMsg.Cargo_Type')">
            <el-select
              v-model="mapperDialog.form.type"
              no="11"
              style="width: 240px;"
            >
              <el-option
                v-for="(item,index) in SystemConstants.OCR_MAPPER_TYPES"
                :key="index"
                :label="isZh ? item.chineseName : item.englishName"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.IdentifyingText')" required>
            <el-input v-model="mapperDialog.form.oldText" no="12" style="width: 240px;" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.mappedValue')" required>
            <el-input v-model="mapperDialog.form.newText" no="13" style="width: 240px;" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button type="primary" no="14" @click="saveMapper">{{ $t('common.btn.save') }}</el-button>
        <el-button no="15" @click="mapperDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>

    <!--字段 校验配置 弹窗-->
    <ocr-field-check-config-dialog
      v-if="ocrFieldCheckConfigDialog.visible"
      :visible.sync="ocrFieldCheckConfigDialog.visible"
      :other-field="otherField"
      :field-define-list="fieldDefineList"
      :field-define-map="fieldDefineMap"
      @cancel="(item) => otherField = item"
      @saveSuccess="initField"
    />
  </div>
</template>

<script>
import { getUserInfo } from '@/utils/auth'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import ColumnUtils from '@/utils/ColumnUtils'
import {
  getOcrList,
  getOcrMapperList,
  saveOcrMapper,
  deleteOcrMapper,
  getOcrFieldList,
  saveOcrField,
  saveMapperApplyHq
} from '@/api/ocrSet'
import { AutoIncrementNum, deepCopy } from '@/utils/commonUtil'
import { SENDING_0, SENDING_4, SENDING_5 } from '@/class/cargo/model/parameters/SystemConstants'
import OcrFieldCheckConfigDialog
  from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/ocrFieldCheckConfigDialog'
import draggable from 'vuedraggable'

export default {
  name: 'OcrRecordSet',
  components: { OcrFieldCheckConfigDialog, draggable },
  data() {
    return {
      isZh: this.$store.getters.language === 'zh',
      SystemConstants,
      ColumnUtils,
      loading: false,
      branchId: 0,
      ifHq: false,
      useCase: 0, // 0 海运出口 1 空运出口
      useField: '',
      action: 'look',
      activeTabName: 'ocrSe',
      otherField: {},
      otherFieldBkg: {}, // 备份
      initialForm: {},
      form: {
        cargoSource: false,
        arriveDate: false, // 预计到货日期
        customCutoff: false, // 截关日期
        customerCutoff: false, // 客户截关日期
        customerShutout: false, // 客户退关时间
        customerFileCutoff: false, // 客户截单时间
        csr: false,
        dc: false,
        insideQuantity: false,
        insidePacking: false,
        chargeWeight: false,
        userDefinedField1: false,
        userDefinedField2: false,
        userDefinedField3: false,
        userDefinedField4: false
      },
      expressList: [],
      currentExpress: null,
      autoIncrementNum: new AutoIncrementNum(),
      selectedRow: null,
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        onRowClicked: event => { this.selectedRow = event.data }
      },
      textRowData: [],
      columnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_Type'),
          field: 'type',
          width: 120,
          cellRenderer: params => {
            return ColumnUtils.columnLabelFunc(SystemConstants.OCR_MAPPER_TYPES, params.value)
          }
        }, {
          headerName: this.$t('SeaExport.IdentifyingText'),
          field: 'oldText',
          width: 200
        }, {
          headerName: this.$t('SeaExport.mappedValue'),
          field: 'newText',
          width: 200
        }
      ],
      gridApi: null,
      mapperDialog: {
        action: 'look',
        visible: false,
        title: '',
        form: {
          uuid: '',
          tenantId: '',
          type: '',
          oldText: '',
          newText: ''
        }
      },
      ocrFieldCheckConfigDialog: {
        visible: false
      },
      SENDING_0,
      fieldDefineList: [],
      fieldDefineMap: null
    }
  },
  computed: {
    currentOfficeList() {
      return getUserInfo().currentUserOfficeList
    },
    readonly() {
      return this.action === 'look'
    },
    isPlatform() {
      return this.$store.getters.tenantId === 1
    }
  },
  mounted() {
    this.refresh()
  },
  created() {
    this.branchId = this.$store.getters.currentOfficeId || 0
    // this.initialForm = this.form
  },
  methods: {
    init() {
      this.loading = getLoading4Cxt(this)
      const params = {
        branchId: this.branchId,
        anyInteger: this.useCase // 应用场景 0海运出口托书识别
      }
      getOcrList(params).then(res => {
        const obj = res.data
        if (obj) {
          if (obj.mapperList && obj.mapperList.length > 0) {
            this.textRowData = obj.mapperList
          }
          // 初始化字段定义列表
          this.fieldDefineList = obj.fieldDefineList
          this.fieldDefineMap = obj.fieldDefineMap
          // 初始化字段选中vo、初始化字段详情
          if (obj.fieldList && obj.fieldList.length > 0) {
            this.otherField = obj.fieldList[0]
            this.ifHq = this.otherField.ifHq
            this.otherFieldBkg = deepCopy(this.otherField)
            // if (this.otherField) {
            //   this.toForm()
            // }
          }
        }
        console.log('otherField.fieldSelectedVo:', this.otherField.fieldSelectedVo)
        this.$forceUpdate()
      }).finally(
        this.loading.close()
      )
    },
    typeList() {
      return [SENDING_0, SENDING_4, SENDING_5]
    },
    initField() {
      this.loading = getLoading4Cxt()
      // this.otherField = {}
      this.expressList = []
      this.form = deepCopy(this.initialForm)
      const params = {
        branchId: this.branchId,
        anyInteger: this.useCase // 应用场景 0海运出口托书识别
      }
      getOcrFieldList(params).then(res => {
        this.loading.close()
        const fieldList = res.data
        if (fieldList && fieldList.length > 0) {
          this.otherField = fieldList[0]
          this.otherFieldBkg = deepCopy(this.otherField)
          this.ifHq = this.otherField.ifHq
          this.toForm()
        }
      }).catch(() => {
        this.loading.close()
      })
    },
    initMapper() {
      this.loading = getLoading4Cxt()
      const params = {
        branchId: this.branchId,
        anyInteger: this.useCase // 应用场景 0海运出口托书识别
      }
      this.textRowData = []
      getOcrMapperList(params).then(res => {
        this.textRowData = res.data || []
      }).catch(() => {
        this.loading.close()
      })
    },
    // 将配置转换成表单
    toForm() {
      const form = deepCopy(this.initialForm)
      const pattern = this.otherField.useField
      if (!pattern) {
        return
      }
      const expressList = []
      let index = -1
      for (let i = 0; i < pattern.length; ++i) {
        if (pattern[i] === '$' && pattern[i + 1] === '{') {
          index = i
          continue
        }
        if (pattern[i] === '}' && index > -1) {
          const name = pattern.substring(index + 2, i)
          const value = true
          expressList.push({ name, text: pattern.substring(index, i + 1), value })
          index = -1
        }
      }
      /* 表达式关联表单数据 */
      for (const item of expressList) {
        form[item.name] = !!item.value
      }
      this.form = form
      this.expressList = expressList
      this.toExample()
    },
    toPattern(name, key = null) {
      const formKey = key || name
      const value = this.form[formKey]
      /* 移除表达式 */
      if (!value) {
        this.form[formKey] = deepCopy(this.initialForm[formKey]) // 取消勾选后，重新初始化
        this.expressList = this.expressList.filter(p => p.name !== name)
        this.toMergeExpress()
        return
      }
      /* 编辑表达式 */
      const expressArr = this.expressList.filter(p => p.name === name)
      let express = null
      if (expressArr.length > 0) {
        express = expressArr[0]
      } else {
        express = { name, value }
        this.expressList.push(express)
      }
      express.text = '${' + name + '}'
      this.toMergeExpress()
    },
    toMergeExpress() {
      let pattern = ''
      for (const item of this.expressList) {
        pattern += item.text
      }
      this.otherField.useField = pattern
      this.toExample()
    },
    toExample() {
      let example = ''
      for (const item of this.expressList) {
        example += item.name
      }
      this.$logger.log('===toExample===', example)
    },
    edit() {
      this.action = 'edit'
    },
    cancel() {
      this.action = 'look'
      // this.initField()
      this.otherField = deepCopy(this.otherFieldBkg)
    },
    saveOcrField(operateIfHq) {
      this.loading = getLoading4Cxt()
      this.otherField.operateIfHq = operateIfHq // 应用总公司配置 改变
      this.otherField.officeId = this.branchId
      this.otherField.ifHq = this.ifHq
      this.otherField.useCase = this.useCase
      saveOcrField(this.otherField).then(res => {
        this.loading.close()
        this.action = 'look'
        this.$message.success(this.$t('common.tips.saveSuccess'))
        this.initField()
      }).catch(() => {
        this.loading.close()
      })
    },
    handleCurrentChange(val) {
      this.currentExpress = val
    },
    // 上移
    moveUp() {
      const expressList = this.expressList
      for (let i = 0; i < expressList.length; ++i) {
        const item = expressList[i]
        if (item.name === this.currentExpress.name) {
          if (i > 0) {
            expressList[i] = expressList[i - 1]
            expressList[i - 1] = this.currentExpress
            this.expressList = [...expressList]
            this.toMergeExpress()
          }
          break
        }
      }
    },
    // 下移
    moveDown() {
      const expressList = this.expressList
      for (let i = 0; i < expressList.length; ++i) {
        const item = expressList[i]
        if (item.name === this.currentExpress.name) {
          if (i < expressList.length - 1) {
            expressList[i] = expressList[i + 1]
            expressList[i + 1] = this.currentExpress
            this.expressList = [...expressList]
            this.toMergeExpress()
          }
          break
        }
      }
    },
    // 更改分公司
    changeBranch() {
      this.refresh()
    },
    refresh() {
      this.textRowData = []
      // this.otherField = {}
      this.expressList = []
      // this.form = deepCopy(this.initialForm)
      this.init()
    },
    // 应用总公司
    applyHq(value) {
      this.saveMapperApplyHq()
      this.saveOcrField(true)
      this.ifHq = value
    },
    handleClick() {},
    // ==========================映射相关==========================
    // 新增
    addMapper() {
      this.mapperDialog.title = this.$t('SeaExport.addMapper')
      this.mapperDialog.form.officeId = this.branchId
      this.mapperDialog.form.ifHq = this.ifHq
      this.mapperDialog.form.type = ''
      this.mapperDialog.form.oldText = ''
      this.mapperDialog.form.newText = ''
      this.mapperDialog.visible = true
    },
    // 编辑
    editMapper() {
      if (!this.selectedRow) {
        this.$message.warning(this.$t('SystemMaintenance.PleaseSelectOneEntry'))
        return
      }
      this.mapperDialog.title = this.$t('SeaExport.editMapper')
      this.mapperDialog.form = this.selectedRow
      this.mapperDialog.visible = true
    },
    // 删除
    deleteMapper() {
      if (!this.selectedRow || !this.selectedRow.uuid) {
        this.$message.warning(this.$t('SystemMaintenance.PleaseSelectOneEntry'))
        return
      }
      const self = this
      self.$confirm(this.$t('CargoMsg.Cargo_SureToDeleteSelectedRecord'), this.$t('CargoMsg.Cargo_Tips'), {
        confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
        cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
        type: 'warning'
      }).then(() => {
        self.loading = getLoading4Cxt()
        deleteOcrMapper({ anyStr: this.selectedRow.uuid }).then(res => {
          self.loading.close()
          if (res.data > 0) {
            self.$message.success(self.$t('common.tips.deleteSuccess'))
            self.initMapper()
          } else {
            self.$message.error(self.$t('common.tips.deleteFailed'))
          }
        }).catch(() => {
          self.loading.close()
        })
      }).catch(() => {
      })
    },
    saveMapperApplyHq() {
      if (!this.textRowData || this.textRowData.length <= 0) {
        return
      }
      this.loading = getLoading4Cxt()
      const params = {
        anyBool: this.ifHq,
        branchId: this.branchId,
        anyInteger: this.useCase,
        keys: Array.from(this.textRowData, p => p.uuid)
      }
      saveMapperApplyHq(params).then(res => {
        this.loading.close()
        this.$message.success(this.$t('common.tips.saveSuccess'))
        this.mapperDialog.visible = false
        this.initMapper()
      }).catch(() => {
        this.loading.close()
      })
    },
    // 保存映射
    saveMapper() {
      if (!this.mapperDialog.form.type) {
        this.$message.warning(this.$t('CargoMsg.Cargo_Type') + this.$t('CargoMsg.Cargo_CanNotEmpty'))
        return
      }
      if (!this.mapperDialog.form.oldText) {
        this.$message.warning(this.$t('SeaExport.IdentifyingText') + this.$t('CargoMsg.Cargo_CanNotEmpty'))
        return
      }
      if (!this.mapperDialog.form.newText) {
        this.$message.warning(this.$t('SeaExport.mappedValue') + this.$t('CargoMsg.Cargo_CanNotEmpty'))
        return
      }
      if (!this.mapperDialog.form.officeId) {
        this.mapperDialog.form.officeId = this.branchId
      }
      if (!this.mapperDialog.form.ifHq) {
        this.mapperDialog.form.ifHq = this.ifHq
      }
      this.loading = getLoading4Cxt()
      saveOcrMapper(this.mapperDialog.form).then(res => {
        this.loading.close()
        this.$message.success(this.$t('common.tips.saveSuccess'))
        this.mapperDialog.visible = false
        this.initMapper()
      }).catch(() => {
        this.loading.close()
      })
    },
    // 复选框选中处理
    fieldCheckboxHandle(fieldDefine) {
      if (this.otherField.fieldSelectedVo[fieldDefine.code]) {
        const serialNumber = this.otherField.ocrOtherFieldDetails[this.otherField.ocrOtherFieldDetails.length - 1].serialNumber + 1
        this.otherField.ocrOtherFieldDetails.push({ code: fieldDefine.code, name: fieldDefine.chineseName, ifCheck: false,
          serialNumber: serialNumber })
      } else {
        const indexToRemove = this.otherField.ocrOtherFieldDetails.findIndex(item => item.code === fieldDefine.code)
        const removeField = this.otherField.ocrOtherFieldDetails.find(item => item.code === fieldDefine.code)
        this.otherField.ocrOtherFieldDetails.splice(indexToRemove, 1)

        if (removeField.uuid) {
          if (!this.otherField.deletedOtherFieldDetailUuids) {
            this.otherField.deletedOtherFieldDetailUuids = []
          }
          this.otherField.deletedOtherFieldDetailUuids.push(removeField.uuid)
        }

        // 后续所有数据的 serialNum 减一
        for (let i = indexToRemove; i < this.otherField.ocrOtherFieldDetails.length; i++) {
          this.otherField.ocrOtherFieldDetails[i].serialNumber--
          this.otherField.ocrOtherFieldDetails[i].ifModified = true
        }
      }
    },
    // 校验配置弹窗
    checkSetting() {
      this.ocrFieldCheckConfigDialog.visible = true
    },
    // 拖拽事件
    onDragUpdate(event) {
      // console.log('event:', event)
      // console.log('otherField.ocrOtherFieldDetails:', this.otherField.ocrOtherFieldDetails)

      const minIndex = event.oldIndex < event.newIndex ? event.oldIndex : event.newIndex
      const maxIndex = event.oldIndex < event.newIndex ? event.newIndex : event.oldIndex
      this.otherField.ocrOtherFieldDetails.forEach((item, index) => {
        if (index >= minIndex && index <= maxIndex) {
          item.serialNumber = index + 1
          item.ifModified = true
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.show-right {
  background-color: #FFFFFF;
  display: flex;
  //float: left;
  width: 100%;
  min-width: 1000px;
  overflow-x: auto;
  margin-top: 5px;
  .left {
    min-width: 535px;
    //display: block;
    //float: left;
    //width: calc(30% - 6px);
  }
  .division {
    background-color: #2d2f33;
    display: table;
    //float: left;
    min-width: 1px;
    margin-bottom: 10px;
    height: 100%;
    margin-left: 50px;
    margin-top: 70px
  }
  .middle {
    //display: block;
    //float: left;
    //width: calc(30% - 6px);
    min-width: 550px;
  }
  .right {
    //display: block;
    //float: left;
    //width: calc(30% - 6px);
    min-width: 450px;
  }
}
</style>
